import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  OccConfig,
  provideConfig,
  provideDefaultConfig,
  UrlModule
} from '@spartacus/core';
import { IconModule, LayoutConfig, SpinnerModule } from '@spartacus/storefront';
import { CustomManufacturerCampaignComponent } from './components/custom-manufacturer-campaign/custom-manufacturer-campaign.component';
import { ManufacturerCampaignInstructionsComponent } from './components/manufacturer-campaign-instructions/manufacturer-campaign-instructions.component';
import { CustomManufacturerCampaignAdapter } from './custom-manufacturer-campaign.adapter';
import { CustomManufacturerCampaignEffects } from './store/custom-manufacturer-campaign.effects';
import { customManufacturerCampaignFeatureKey, customManufacturerCampaignReducer } from './store/custom-manufacturer-campaign.reducer';
import { UigManufacturerCampaignGuard } from './uig-manufacturer-campaign.guard';
import { CustomManufacturerCampaignDetailsComponent } from './components/custom-manufacturer-campaign-details/custom-manufacturer-campaign-details.component';
import { CustomManufacturerCampaignExportComponent } from './components/custom-manufacturer-campaign-export/custom-manufacturer-campaign-export.component';

@NgModule({
  declarations: [CustomManufacturerCampaignComponent,ManufacturerCampaignInstructionsComponent, CustomManufacturerCampaignDetailsComponent, CustomManufacturerCampaignExportComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    FormsModule,
    NgSelectModule,
    RouterModule,
    UrlModule,
    IconModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            customManufacturerCampaignOverview: '/myrio/manufacturercampaign/search',
            customManufacturerCampaignSalesNotificationUpload: '/myrio/manufacturercampaign/upload',
            customManufacturerCampaignDetails: '/myrio/manufacturercampaign/salesnotification',
            customManufacturerCampaignSalesNotificationUpdate: '/myrio/manufacturercampaign/updatesalesnotification',
            customManufacturerCampaignExport: '/myrio/manufacturercampaign/export',
            customManufacturerCampaignCalendarDownload: '/myrio/manufacturercampaign/downloadCalendar',
          },
        },
      },
    } as OccConfig),
    StoreModule.forFeature(
      customManufacturerCampaignFeatureKey,
      customManufacturerCampaignReducer
    ),
    EffectsModule.forFeature([CustomManufacturerCampaignEffects])
  ],
  providers: [
    provideConfig(<CmsConfig | LayoutConfig>{
      cmsComponents: {
        ManufacturerCampaignComponent: {
          component: CustomManufacturerCampaignComponent,
          guards :[AuthGuard ,UigManufacturerCampaignGuard]
        }
      }
    }),
    {
      provide: CustomManufacturerCampaignAdapter,
      useClass: CustomManufacturerCampaignAdapter,
    },
  ],
})
export class CustomManufacturerCampaignModule { }
